"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var searchBaseTheme = function (_a) {
    var _b, _c, _d, _e, _f, _g, _h;
    var MIN_M = _a.MIN_M, MAX_M = _a.MAX_M;
    return ({
        searchIndexResultsTitle: (_b = {
                padding: "1rem 2.25rem",
                maxWidth: "1440px",
                margin: "0 auto",
                fontSize: "1.875rem"
            },
            _b[MAX_M] = {
                padding: "1rem",
            },
            _b),
        searchIndexNavbar: (_c = {
                overflow: "auto",
                width: '315px',
                display: "flex",
                flexDirection: "column"
            },
            _c[MAX_M] = {
                display: "none",
            },
            _c),
        searchIndexNavbarContainer: {
            flexGrow: 1,
            maxHeight: "100%",
        },
        searchIndexSectionsFilter: {
            margin: "0 0.5rem",
        },
        searchIndexPagination: {
            border: "1px solid #bdbdbd",
            display: "flex",
            justifyContent: "center",
            marginTop: "30px",
        },
        searchIndexFiltersTitle: {
            fontSize: "1.125rem",
            alignItems: "flex-end",
            display: "flex",
            lineHeight: "1.75rem",
            marginLeft: "2.25rem",
        },
        searchIndexFiltersButton: (_d = {
                backgroundColor: "#022A5E",
                color: "#fff",
                textTransform: "capitalize",
                marginRight: "1rem"
            },
            _d[MIN_M] = {
                display: "none"
            },
            _d),
        searchIndexFiltersButtonGroup: (_e = {},
            _e[MIN_M] = {
                display: "none"
            },
            _e),
        searchIndexFiltersButtonGroupMobile: {
            display: "block",
            position: "relative",
            margin: "1.25rem 0 0 1rem",
        },
        searchIndexApplyFiltersButton: {
            backgroundColor: "#022A5E",
            color: "#fff",
            textTransform: "capitalize",
            width: "125px",
            marginRight: "1rem",
        },
        searchIndexFilterDrawer: {
            minWidth: "50%"
        },
        searchIndexFilterDrawerContainer: {},
        searchIndexClearFiltersButton: {
            textTransform: "none",
            border: "1px solid #bdbdbd",
            height: "1.5rem",
            "& .MuiButton-label": {
                lineHeight: 1,
                fontSize: "12px",
            },
        },
        searchIndexClearFiltersButtonMobile: (_f = {
                right: "0.25rem",
                position: "absolute"
            },
            _f[MIN_M] = {
                display: "none"
            },
            _f),
        searchIndexNavbarTitleContainer: {
            display: "flex",
            alignItems: "center",
            flexDirection: "row",
            justifyContent: "space-between",
            borderBottom: "1px #bdbdbd solid"
        },
        searchIndexResultsItem: (_g = {
                marginBottom: "1rem",
                padding: "1rem 0",
                textDecoration: "none",
                "&:last-child": {
                    marginBottom: 0,
                }
            },
            _g[MAX_M] = {
                borderBottom: "1px solid #bdbdbd",
            },
            _g),
        searchIndexResults: {
            flex: 1,
            height: "100%",
            minHeight: "750px",
        },
        searchIndex: (_h = {
                flex: "1",
                maxWidth: "1440px",
                width: "100%",
                margin: "0 auto",
                display: "flex",
                padding: "0 1rem"
            },
            _h[MIN_M] = {
                padding: "0 2.25rem",
                display: "grid",
                gridTemplateColumns: "315px auto",
                gridGap: "2rem",
            },
            _h),
        searchFacets: {},
        sectionsFilter: {
            width: "100%",
            "&  .MuiTypography-body1": {
                fontSize: "13px",
            },
        },
        sectionsFilterWrapper: {
            marginLeft: "0.625rem",
            display: "flex",
            flexDirection: "column",
            alignItems: "flex-start",
            "& .mui-checkbox_root": {
                width: "2.375rem",
                height: "1.875rem"
            },
            "& .MuiSvgIcon-root": {
                fontSize: "1.125rem",
            },
            "& .MuiFormControlLabel-root": {},
            "& .react-checkbox-tree ol ol": {
                paddingLeft: "1.125rem"
            },
            "& .rct-title > *": {
                borderBottom: "none",
            },
            "& .rct-node-expanded .rct-collapse-btn": {
                display: "flex",
                "& .material-icons": {
                    display: "inline",
                },
                transform: "rotate(90deg) translate(-2px, 0)"
            },
            "& .rct-node-collapsed .rct-collapse-btn": {
                transform: "rotate(0deg) translate(-2px, 0)"
            },
            "& .rct-node": {
                "& .material-icons": {
                    fontSize: "1.125rem"
                },
                margin: "0.5rem 0"
            },
            "& .rct-node-leaf": {},
            "& .MuiTypography-root.MuiFormControlLabel-label.MuiTypography-body1": {
                fontSize: "0.75rem",
            },
        }
    });
};
exports.default = searchBaseTheme;
//# sourceMappingURL=searchIndex.js.map